export type CommunityMovedInfo = {
  destinationUrl: string;
  destinationDomain: string;
  displayName: string | null;
};

const getApiOrigin = (): string => {
  if (typeof window !== 'undefined') {
    return '';
  }

  if (process.env.NEXT_PUBLIC_API_URL) {
    return process.env.NEXT_PUBLIC_API_URL.replace(/\/$/, '');
  }

  const apolloUri = process.env.NEXT_PUBLIC_APOLLO_HTTP_URI;
  if (apolloUri) {
    return apolloUri.replace(/\/graphql2\/?$/, '');
  }

  return '';
};

export const fetchCommunityMoved = async (
  domain: string | null | undefined
): Promise<CommunityMovedInfo | null> => {
  if (!domain) {
    return null;
  }

  try {
    const origin = getApiOrigin();
    const response = await fetch(
      `${origin}/api/v1/community-moved?domain=${encodeURIComponent(domain)}`
    );

    if (!response.ok) {
      return null;
    }

    const payload = (await response.json()) as {
      moved?: boolean;
      destinationUrl?: string;
      destinationDomain?: string;
      displayName?: string | null;
    };

    if (!payload.moved || !payload.destinationUrl || !payload.destinationDomain) {
      return null;
    }

    return {
      destinationUrl: payload.destinationUrl,
      destinationDomain: payload.destinationDomain,
      displayName: payload.displayName ?? null,
    };
  } catch {
    return null;
  }
};
